import util from "@/common/js/util";
import constants from "@/common/constants";


export default {

    async getList(){
        return util.cache({
            key: constants.carrierCodeKey,
            fetch: () => util.axios.post("basic/queryPlatform"),
            handle: res =>( res.module || []).map(e=>({
                value:e.name,
                label:e.name,
                key:e.code
            })),
        });

    }
}


// WEBPACK FOOTER //
// ./src/common/api/platform.js